export default {
  // Contact Labels
  contactLabel: "Contact",
  contactTitle: "Get in Touch",
  phoneLabel: "Phone",
  emailLabel: "Email",
  whatsappLabel: "WhatsApp",
  locationLabel: "Office Location",
  callUs: "Call Us",

  // Navbar
  navHome: "Home",
  navAbout: "About Us",
  navServices: "Services",
  navBusiness: "Investment & Business",
  navTenders: "Tender Opportunities",
  navEvents: "Investment Events",
  navContact: "Contact",
  navGetInTouch: "Get in Touch",
  navLocation: "Kigali, Rwanda",
  navPhone: "+250 788 377 109",
  navWhatsApp: "WhatsApp Us",
  navEmail: "info@africainvestmentportal.com",
  navLinkedIn: "LinkedIn",
  navTwitter: "Twitter",

  // Footer
  footerTagline: "Your trusted partner for investment, compliance & business facilitation in East Africa.",
  footerServices: "Services",
  footerSectors: "Sectors",
  footerCompany: "Company",
  footerLegal: "Legal",
  footerCompanyRegistration: "Company Registration",
  footerRegulatoryCompliance: "Regulatory Compliance",
  footerInvestmentFacilitation: "Investment Facilitation",
  footerTenderSupport: "Tender Support",
  footerBusinessExpansion: "Business Expansion",
  footerHealthPharma: "Health & Pharma",
  footerEducation: "Education",
  footerAgriculture: "Agriculture",
  footerMining: "Mining",
  footerManufacturing: "Manufacturing",
  footerAboutUs: "About Us",
  footerEvents: "Events",
  footerBusiness: "Business",
  footerContact: "Contact",
  footerPrivacyPolicy: "Privacy Policy",
  footerTermsOfService: "Terms of Service",
  footerCopyright: "© {year} Africa Investment Portal. All rights reserved.",
  footerLocation: "Kigali, Rwanda · East Africa",
  footerAIP: "AIP",

  // Not Found
  notFoundTitle: "This page has not been generated",
  notFoundPrompt: "Tell me more about this page, so I can generate it",

  // Language
  language: "Language",
  en: "English",
  fr: "Français",

  // Generic
  learnMore: "Learn more",
  viewAll: "View All",
  registerNow: "Register Now",
  submit: "Submit",
  cancel: "Cancel",
  close: "Close",
  back: "Back",
  details: "View Details",
  expressInterest: "Express Interest",
  startNow: "Start Now",
  processing: "Processing...",
  sent: "Sent!",
  clearFilters: "Clear filters",
  filterBy: "Filter:",
  found: "found",
  step: "Step",
  why: "Why",
  days: "days",
  avgRegistration: "Avg. Registration",
  minCapital: "Min. Capital",
  foreignOwnership: "Foreign Ownership",
  required: "*",
  fullName: "Full Name",
  email: "Email Address",
  phone: "Phone Number",
  company: "Company",
  country: "Country",
  sector: "Sector",
  message: "Message",
  additionalInfo: "Additional Information",
  selectCountry: "Select a country",
  selectSector: "Select a sector",
  successTitle: "Application Received!",
  successBody: "Our team will reach out within 24 hours to guide your next steps.",
  submitAnother: "Submit another application",
  noResults: "No results match your filters",
  tryAdjusting: "Try adjusting your selection",
  readMore: "Read more",
  loading: "Loading...",
  contactUs: "Contact Us",
  exploreServices: "Explore Services",
};